export default {
  data() {
    return {
      LIMIT_LIST: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '未生效',
          value: '5',
        },
        {
          text: '生效中',
          value: '1',
        },
        {
          text: '已失效',
          value: '3',
        },
      ],
      TYPE_LIST: [
        {
          text: '信用限额',
          value: '1',
        },
        {
          text: '正常额度',
          value: '2',
        },
        {
          text: '临时额度',
          value: '3',
        },
        {
          text: '专项额度',
          value: '4',
        },
      ],
      STATUS_LIST: [
        {
          text: '全部',
          value: '',
        },
        {
          text: '审核中',
          value: '1',
        },
        {
          text: '审批通过',
          value: '2',
        },
        {
          text: '审批否决',
          value: '3',
        },
        {
          text: '已撤销',
          value: '4',
        },
      ],
      searchSchema: [
        {
          label: '额度类型',
          itemName: 'type',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '业务类型',
          itemName: 'businessId',
          type: 'select',
          selectList: [],
          allowClear: true,
          handleChange: this.changeBusiness,
        },
        {
          label: '状态',
          itemName: 'status',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '额度状态',
          itemName: 'amountStatus',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '信控区',
          itemName: 'creditRange',
          type: 'select',
          selectList: [],
          allowClear: true,
        },
        {
          label: '有效期',
          itemName: 'indateEnd',
          type: 'datePicker',
          format: 'YYYY-MM-DD',
          allowClear: true,
        },
      ],
      searchData: {
        amountStatus: '',
        companyCode: '',
        type: '',
        businessId: '',
        status: '',
        creditRange: '',
        indateEnd: '',
      },
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
        },
        {
          title: '额度类型',
          dataIndex: 'creditTypeStr',
        },
        {
          title: '限额生效日',
          dataIndex: 'indateStart',
        },
        {
          title: '限额条件—AR超限控货(元)',
          dataIndex: 'limitConditionAmount',
          scopedSlots: { customRender: 'limitConditionAmount' },
        },
        {
          title: '申请类型',
          dataIndex: 'automaticStr',
        },
        {
          title: '专项凭证号',
          dataIndex: 'financeDocNumber',
          width: 160,
        },
        {
          title: 'Financialtransaction',
          dataIndex: 'bgNum',
          width: 160,
        },
        {
          title: '业务类型',
          dataIndex: 'business',
        },
        {
          title: '信控区',
          dataIndex: 'creditRange',
        },
        {
          title: '额度生效状态',
          dataIndex: 'amountStatusStr',
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
        },
        {
          title: '最终批复日期',
          dataIndex: 'reviewDate',
        },
        {
          title: '到期日',
          dataIndex: 'indateEnd',
        },
        {
          title: '原始有效期',
          dataIndex: 'oldIndateEnd',
        },
        {
          title: '调整后到期日',
          dataIndex: 'reducedIndateEnd',
        },
        {
          title: '金额单位',
          dataIndex: 'unit',
        },
        {
          title: '最终批复额度',
          dataIndex: 'reviewAmount',
          scopedSlots: { customRender: 'reviewAmount' },
        },
        {
          title: '调减后额度',
          dataIndex: 'reducedAmount',
          scopedSlots: { customRender: 'reducedAmount' },
        },
        {
          title: '申请后总限额/总额度',
          dataIndex: 'finalAmount',
          scopedSlots: { customRender: 'finalAmount' },
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
        },
        {
          title: '操作',
          fixed: 'right',
          width: 120,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
